/**
 * Checks if password provided is valid
 */
export default function validatePassword(password: string): boolean {
    return password.length >= 6
}
